import React, { useContext, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import {
  API_ENDPOINT,
  primaryPaletteColor,
} from '../../../../configurations/global.config';
import { BlockPicker, ChromePicker, CompactPicker, MaterialPicker, SketchPicker } from 'react-color';
import { OrganisationSettings } from '../../../../interfaces/delivery-company/orders';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import axios from 'axios';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';
import { isMobile, isTablet } from 'react-device-detect';
import ImageUploader from '../../../common/image-upload/logo-uploader';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useSnackBar } from '../../../../contexts/snackbar';

interface ThemeColorProps {
  settings: OrganisationSettings;
}

const ThemeColor = ({ settings }: ThemeColorProps) => {
  const [inputColor, setInputColor] = useState(
    settings.custom_primary_color || primaryPaletteColor
  ); // Default color
  const { setColor, setSettings } = useContext(OrgSettingsContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null); // Success message state

  const { user, config } = useContext(AuthContext);

  const {showMessage} = useSnackBar()

  const handleChangeComplete = (color: any) => {
    setInputColor(color.hex); // Update the color state
  };

  const handleSubmitColor = async () => {
    setError(null);
    setSuccessMessage(null);
    setLoading(true);

    try {
      const requestData = {
        custom_primary_color: inputColor,
      };

      await axios.post(`${API_ENDPOINT}/api/v1/settings`, requestData, config);
      showMessage("Theme color updated successfully", "success")
      setColor(inputColor);
      setSettings({...settings, custom_primary_color: inputColor})
    } catch (err) {
      setError('Failed to update theme color. Please try again.');
    }

    setLoading(false);
  };

  const handleSubmitLogo = async (navbar_logo_url: string | null) => {
    setError(null);
    setSuccessMessage(null);
    setLoading(true);

    try {
      const requestData = {
        navbar_logo: navbar_logo_url,
      };

      await axios.post(`${API_ENDPOINT}/api/v1/settings`, requestData, config);
      showMessage("Icon uploaded successfully.", "success")
      setSettings({...settings, navbar_logo: navbar_logo_url})
      setColor(inputColor);

    } catch (err) {
      setError('Failed to update theme color. Please try again.');
    }

    setLoading(false);
  };

  return (
    <Box>
      <>
        {error && <Alert severity="error">{error}</Alert>}

        {successMessage && <Alert severity="success"> {successMessage} </Alert>}

        {(error || successMessage) && <br />}
      </>
      <Alert severity='info'>Upload a navigation bar icon and choose a color.</Alert>

          <ImageUploader  onUploaded={handleSubmitLogo} defaultImageUrl={settings.navbar_logo ?? ''} />

          <Box mt={1} mb={1} display={"flex"} width={"100%"} justifyContent={"center"} alignItems={"center"} gap={1} flexDirection={"column"}>
            
              <CompactPicker
                color={inputColor}
                onChangeComplete={handleChangeComplete}
              />
               <Button size="small" sx={{visibility: settings.custom_primary_color != inputColor ? 'visible' : 'hidden'}} variant='contained' onClick={handleSubmitColor}>Save Color</Button>

          </Box>

    </Box>
  );
};

export default ThemeColor;
